export enum TRANSACTION_VIEWS {
  DECISION = 'DECISION',
  REPORT = 'REPORT',
}
